<template>
    <div>
        <ul class="tool-list hidden-md-and-down" :style="{right:toolRight+'px'}">
            <li class="tool-shoppingcart" @click="gorouter('/shoppingCart')">
                <span class="shoppingcartNum" :class="{'addingClass':adding}" v-if="carts > 0">{{carts}}</span>
                <!-- <p class="contact-qq">371689655</p> -->
                <!-- <a class="openqq" target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=371689655&site=qq&menu=yes"></a> -->
            </li>
            <li class="tool-weibo">
                <p class="contact-qq">371689655</p>
                <a class="openqq" target="_blank" href="http://weibo.com/u/6135537891"></a>
            </li>
            
            <li class="tool-wechat">
                <a class="openqq" target="_blank" href="http://weibo.com/u/6135537891"></a>
                
                <img class="wechat-img" width="80" src="https://p1.fishqc.net/FpRCj8D-jfZABkh3Mi9yQDrYkuYv" alt="">
            </li>
            <li class="tool-facebook">
                <p class="contact-qq">371689655</p>
                <a class="openqq" target="_blank" href="https://www.facebook.com/Vitargent/"></a>
            </li>
            <li class="tool-link">
                <p class="contact-qq">371689655</p>
                <a class="openqq" target="_blank" href="https://www.linkedin.com/m/company/2086233"></a>
            </li>
            
            <transition name="fade">
                <li v-show="showToTop" class="tool-totop" @click="toTop">
                    <img class="up-img" src="http://p1.fishqc.net/Fkh9b4KWy2gBzeCe-bB7FcxYbCDn" alt="">
                    <a class="up-text" href="javascript:;">回到<br/>顶部</a>
                </li>
            </transition>
        </ul>
    </div>
</template>

<script>
import { myMixin } from '@/mixin/mixin.js'

    export default {
        data() {
            return {
                toolRight: 40,
                showToTop: false,
                adding:false
            }
        },
        mixins: [myMixin],
        methods: {
            toTop(){
                // window.scrollTo(0,0);
                this.scrollToY(0, 1500, 'easeInOutQuint');
            },
            handleScroll() {
                let dom =document.getElementsByClassName('content-container')[0];
                // console.log('elTop>>>>>>>>>>>',dom.scrollTop)
                let sTop = document.documentElement.scrollTop == 0 ? document.body.scrollTop : document.documentElement.scrollTop;
                // console.log('documentTop>>>',sTop);
                if(sTop > 500 || dom > 500){
                    this.showToTop = true
                }else{
                    this.showToTop = false;
                }
                // this.scrollTop = dom.scrollTop;
                // if (this.scrollTop > 300) {
                //     this.toTopShow = true;
                // }else {
                //     this.toTopShow = false;
                // }
            },
            
        },
        mounted(){
            var winWidth = document.documentElement.clientWidth || document.body.clientWidth;
            var rightGap = (winWidth-1200)/2;
            this.toolRight = rightGap > 0 ? rightGap*0.35 : 0;
            this.shopcartposition = this.toolRight
            this.$nextTick(function () {
                window.addEventListener('scroll', this.handleScroll,true);
            });
        },
        watch:{
            'carts'(val){
                var that = this
                this.adding = true
                setTimeout(function(){
                    that.adding  = false
                },2000)
            }
        },
        computed:{
            carts(){
                return this.$store.state.shopcart
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.tool-list{
    width: 50px;
    // height: 300px;
    position: fixed;
    bottom: 30px;
    z-index: 999999;
    // transition: all .3s;
    &>li{
        @extend .display_flex;
        @extend .justify-content_flex-center;
        @extend .align-items_center;
        width: 48px;
        height: 48px;
        border-radius: 100%;
        background-color:#D5D5D7;
        margin-bottom: 10px;
        background-repeat: no-repeat;
        background-size: 60%;
        background-position: center;
        cursor: pointer;
        position: relative;
        // transition: all .4s;
            &.tool-shoppingcart{
                background-image: url('http://p1.fishqc.net/FrcjFKVCER2KuQ3TNNoOl3H7-OTK');
                background-size:25px 21px;
                position:relative;
                .shoppingcartNum{
                    position:absolute;
                    right:0;
                    top:-3px;
                    box-sizing:border-box;
                    border-radius:50%;
                    background-color:#FF7467;
                    display:inline-block;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 20px;
                    height:20px;
                    width:20px;
                    
                    &.addingClass{
                        animation-name: example;
                        animation-duration: 2s;
                    }
                }
                    .contact-qq{
                        height: 40px;
                        line-height: 40px;
                        border-radius:100px 0 0 100px;
                        color: #ffffff;
                        background-color: $maincolor;
                        position: absolute;
                        padding:0 10px;
                        width: 100px;
                        text-align: center;
                        top: 50%;
                        transform: translate(-90%,-50%);
                        left: 0;
                        display: none;
                    }
                    .openqq{
                      width: 100%;
                      height: 100%;
                      display: inline-block;
                      position: absolute;
                      left: 0;
                      right: 0;
                    }
            }
            &.tool-weibo{
                background-image: url('http://p1.fishqc.net/FtZ7Vjj1vWneBTjsiz572Ud_TkVR');
                background-size:29px 24px;
                    .contact-qq{
                        height: 40px;
                        line-height: 40px;
                        border-radius:100px 0 0 100px;
                        color: #ffffff;
                        background-color: $maincolor;
                        position: absolute;
                        padding:0 10px;
                        width: 100px;
                        text-align: center;
                        top: 50%;
                        transform: translate(-90%,-50%);
                        left: 0;
                        display: none;
                    }
                    .openqq{
                      width: 100%;
                      height: 100%;
                      display: inline-block;
                      position: absolute;
                      left: 0;
                      right: 0;
                    }
            }
            &.tool-facebook{
                background-image: url('http://p1.fishqc.net/Ft72obFWMFkVolIktRYqvueDKe_z');
                background-size:16px 31px;
                    .contact-qq{
                        height: 40px;
                        line-height: 40px;
                        border-radius:100px 0 0 100px;
                        color: #ffffff;
                        background-color: $maincolor;
                        position: absolute;
                        padding:0 10px;
                        width: 100px;
                        text-align: center;
                        top: 50%;
                        transform: translate(-90%,-50%);
                        left: 0;
                        display: none;
                    }
                    .openqq{
                      width: 100%;
                      height: 100%;
                      display: inline-block;
                      position: absolute;
                      left: 0;
                      right: 0;
                    }
            }

            &.tool-link{
                background-image: url('http://p1.fishqc.net/FlJreTGRvlmEBMmMon2oNikxlLeJ');
                background-size:24px 24px;
                    .contact-qq{
                        height: 40px;
                        line-height: 40px;
                        border-radius:100px 0 0 100px;
                        color: #ffffff;
                        background-color: $maincolor;
                        position: absolute;
                        padding:0 10px;
                        width: 100px;
                        text-align: center;
                        top: 50%;
                        transform: translate(-90%,-50%);
                        left: 0;
                        display: none;
                    }
                    .openqq{
                      width: 100%;
                      height: 100%;
                      display: inline-block;
                      position: absolute;
                      left: 0;
                      right: 0;
                    }
            }
            &.tool-wechat{
                background-image: url('http://p1.fishqc.net/FjUaPpmVj9xT5018CESsNd7kEQV1');
                background-size:30px 24px;
                    .wechat-img{
                        position: absolute;
                        top: 50%;
                        left: -185%;
                        transform: translateY(-50%);
                        display: none;
                    }
            }
            &.tool-phone{
                    .contact-img{
                        width: 60%;
                        z-index:99;
                    }
                    .contact-tel{
                        height: 40px;
                        line-height: 40px;
                        border-radius:100px 0 0 100px;
                        color: #ffffff;
                        background-color: $maincolor;
                        position: absolute;
                        padding:0 10px;
                        width: 120px;
                        text-align: center;
                        top: 50%;
                        transform: translate(-90%,-50%);
                        left: 0;
                        display: none;
                    }
            }
            &.tool-email{
                .contact-img{
                    // width: 70%;
                    z-index:9;
                }
                .contact-email{
                    height: 40px;
                    line-height: 40px;
                    border-radius:100px 0 0 100px;
                    color: #ffffff;
                    background-color: $maincolor;
                    position: absolute;
                    padding:0 10px;
                    width: 200px;
                    text-align: center;
                    top: 50%;
                    transform: translate(-90%,-50%);
                    left: 0;
                    display: none;
                }
                .open-mail{
                  width: 100%;
                  height: 100%;
                  display: inline-block;
                  position: absolute;
                  left: 0;
                  right: 0;
                  z-index: 10;
                }
            }
            &.tool-totop{
                .up-img{
                    width: 60%;
                    display: block;
                }
                .up-text{
                    display: none;
                    color: #ffffff;
                    text-align: center;
                    font-size: 12px;
                    line-height: 14px;
                }
            }
        &:hover{
            background-color: $maincolor;
            &.tool-shoppingcart{
                .contact-qq{
                    display: block;
                }
            }
            &.tool-qq{
                .contact-qq{
                    display: block;
                }
            }
            &.tool-wechat{
                    .wechat-img{
                        display: block;
                    }
            }
            &.tool-phone{
                    .contact-tel{
                        display: block;
                    }
            }
            &.tool-email{
                    .contact-email{
                        display: block;
                    }
            }
            &.tool-totop{
                .up-img{display: none;}
                .up-text{
                    display:block;
                    text-decoration: none;
                }
            }

        }

    }


}

@keyframes example {
    0%{
        transform: scale(1);  /*开始为原始大小*/
    }
 
    50%{
        transform: scale(1.5);
    }
    100%{
        transform: scale(1);
    }
}
</style>
